import { render, staticRenderFns } from "./AchievementLibrary.vue?vue&type=template&id=4706e2c0&scoped=true"
import script from "./AchievementLibrary.vue?vue&type=script&lang=js"
export * from "./AchievementLibrary.vue?vue&type=script&lang=js"
import style0 from "./AchievementLibrary.vue?vue&type=style&index=0&id=4706e2c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706e2c0",
  null
  
)

export default component.exports